/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "2.2.0",
  "gitBuildTime": "2024-10-16T15:16:00.994Z",
  "gitBuildVersion": "2.2.0",
  "gitCommitId": "c4b2753",
  "gitCommitIdFull": "c4b2753c957c4392f3c5eb49011ef6cfaa790161",
  "gitCommitTime": "2024-10-16T15:10:15.000Z",
  "version": "2.2.0-2024-10-16T15:10:15.000Z-(c4b2753)"
};
